import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import * as moment from 'moment';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';

@Component({
  selector: 'app-datetime-picker',
  templateUrl: './datetime-picker.component.html',
  styleUrls: ['./datetime-picker.component.sass'],
})
export class DatetimePickerComponent implements OnInit {
  @Input()
  config: IFieldConfig;
  @Input()
  group: FormGroup;
  @Input()
  typeCes?: TypeCesEnum | undefined;

  constructor() { }

  ngOnInit(): void { }
}
